module.exports = "<p>\r\n  izvestaj-toolbar works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/izvestaj-toolbar/izvestaj-toolbar.component.html
// module id = ./src/app/components/izvestaj-toolbar/izvestaj-toolbar.component.html
// module chunks = main